export default __webpack_public_path__ + "static/media/attendance-white.dc57b2c4.svg";